"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Dog;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Dog(_ref) {
  var {
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Group 840"
  }, /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector",
    d: "M21.9284 60.1873C20.6437 60.3091 19.3496 60.2923 18.0684 60.1373C14.8384 59.9273 14.1484 58.5673 14.1484 58.5673C14.2584 54.8773 20.1484 54.4273 20.1484 54.4273C20.3784 50.8773 20.1484 44.0873 20.1484 44.0873C18.8752 43.5229 17.7936 42.6003 17.0355 41.4319C16.2773 40.2636 15.8753 38.9001 15.8784 37.5073C15.7384 32.5073 17.6184 24.7773 17.6184 24.7773M30.3484 57.0773C26.3484 53.5273 25.5184 46.2473 29.6584 41.0073L30.3484 57.0773ZM49.6284 56.1873C49.6284 56.1873 49.9184 62.5873 43.8584 62.5773C41.1584 62.5773 29.2584 62.5773 25.3484 62.5773C21.4384 62.5773 21.9284 60.7073 21.9284 60.7073C22.7784 55.8673 35.1084 57.1173 35.2284 57.4673L49.6284 56.1873Z",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_2",
    d: "M19.56 21.7387C15.49 20.4587 8.17 22.7388 6.22 22.0288C4.27 21.3188 1.76 18.8688 1 13.0288C3.62028 12.2623 6.29449 11.6941 9 11.3287C9.49812 11.2893 9.973 11.1015 10.3634 10.7896C10.7537 10.4776 11.0417 10.0559 11.19 9.57874C12.19 6.36874 12.19 4.16874 13.59 3.88874C15.22 3.55874 24.02 -0.841259 27.39 1.88874C30.76 4.61874 33.39 12.0287 32.5 14.6387C31.87 16.5387 28.22 17.3487 25.41 17.3887C24.7327 17.4022 24.0777 17.1466 23.5885 16.678C23.0993 16.2094 22.8157 15.566 22.8 14.8887C22.7 10.8887 22.39 6.80872 22.39 6.80872",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_3",
    d: "M46.9989 43.468C42.6089 33.968 35.2989 25.748 32.6489 23.748C29.3289 21.248 30.3089 18.108 30.4689 16.418",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_4",
    d: "M49.3008 58.546C52.4508 58.426 67.0108 55.326 60.9708 38.316C58.1808 30.466 54.7108 27.316 52.6708 27.986C50.8308 28.606 51.1808 30.396 52.1008 31.496C55.8408 35.916 63.8008 49.416 49.6608 50.856",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_5",
    d: "M50.7488 44.2778C50.7488 45.1425 50.4053 45.9716 49.7939 46.583C49.1826 47.1943 48.3534 47.5378 47.4888 47.5378C47.0598 47.5391 46.6348 47.4558 46.2381 47.2926C45.8415 47.1293 45.4809 46.8894 45.1771 46.5865C44.8733 46.2837 44.6323 45.9238 44.4679 45.5277C44.3034 45.1315 44.2188 44.7068 44.2188 44.2778C44.2174 43.8481 44.3011 43.4222 44.465 43.0249C44.6289 42.6275 44.8697 42.2666 45.1736 41.9627C45.4775 41.6588 45.8385 41.4179 46.2358 41.254C46.6332 41.0902 47.059 41.0065 47.4888 41.0078C47.9177 41.0078 48.3424 41.0925 48.7386 41.2569C49.1348 41.4214 49.4946 41.6624 49.7975 41.9662C50.1003 42.27 50.3402 42.6305 50.5035 43.0272C50.6667 43.4239 50.7501 43.8489 50.7488 44.2778",
    fill: "#54C8E8"
  })));
}